import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { BodyCargaPlanes } from 'src/app/interfaces/body_cargaPlanes';
import { BodyEnvioPlanes } from 'src/app/interfaces/body_envioPlanes';
import { BodyInactividadCotizador } from 'src/app/interfaces/body_inactividad_cotizador';
import { ResponseServices } from 'src/app/interfaces/response-services';
import { DatosGeneralesModel } from 'src/app/models/datosGenenrales';
import { PlanModels } from 'src/app/models/plan_models';
import { ERROR, FIN_FLUJO_NO } from 'src/app/routes.constants';
import { DataLayerService } from 'src/app/services/dataLeyer/data-leyer.service';
import { OrquestadorService } from 'src/app/services/orquestador/orquestador.service';

@Component({
  selector: 'app-card-planes-no',
  standalone: false,
  templateUrl: './card-planes-no.component.html',
  styleUrl: './card-planes-no.component.scss'
})
export class CardPlanesNoComponent implements OnInit {

  private datosGenerales: DatosGeneralesModel = {
    Cliente: {
      cedulaCliente: '',
      celularCliente: '',
      nombreCliente: '',
      tipoIdentificacion: ''
    },
    InfoArrendamiento: {
      tipoPropiedad: '',
      ubicacion: '',
      valorAdministracion: 0,
      valorArriendo: 0,
      fechaContrato: '',
      duracionContrato: '',
      ServiciosPublicos: false,
      PaquetesAsistencia: false
    },
    Propietario: {
      primerNombre: '',
      segundoNombre: '',
      primerApellido: '',
      segundoApellido: '',
      paisNacimiento: '',
      tipoIdentificacion: '',
      numeroIdentificacion: '',
      fechaExpedicion: '',
      correo: ''
    },
    PlanSeleccionado: {
      plan: '',
      valorPlan: 0
    },
    Inmueble: {
      ciudad: '',
      direccion: '',
      maticula: ''
    },
    Inquilino: {
      primerNombre: '',
      segundoNombre: '',
      primerApellido: '',
      segundoApellido: '',
      numCelular: '',
      correo: '',
      paisNacimento: '',
      fechaNacimento: '',
      tipoidentificacion: '',
      documentoIdentidad: '',
      fechaExpedicion: '',
      ciudad: '',
      direccion: ''
    },
    ResponseRiesgoConsultable: [
      {
        esRiesgo: false,
        tipoValidacion: '',
        mensajeValidacion: '',
        idRegistroValidacion: ''
      }
    ]
  }

  json: string = '';
  jsonFinal: string = '';

  dataEnvio: BodyEnvioPlanes = {
    SessionId: '',
    productFamily: '',
    leadId: '',
    asesorCode: '',
    bitacoraId: '',
    screenPercentage: '',
    productsConfigurationData: {
      ProductCode: '',
      PolicyHolder: {
        LastName: '',
        MobilePhone: '',
        PersonalDataAuthorization: false
      },
      Tenant: {
        DocumentNumber: '',
        DocumentType: ''
      },
      Property: {
        TemporaryContracted: '',
        ContractStartDate: '',
        AdministrationValue: 0,
        RentalFee: 0,
        Department: '',
        UseProperty: ''
      }
    }
  };

  dataCarga: BodyCargaPlanes = {
    getPriceData: false,
    productsConfigurationData: {
      Property: {
        AdministrationValue: 0,
        Department: '',
        RentalFee: 0,
        TemporaryContracted: ''
      }
    }
  };

  dataEnvioCotizador: BodyInactividadCotizador = {
    SessionId: '',
    productFamily: '',
    screenPercentage: '',
    leadId: '',
    asesorCode: '',
    bitacoraId: '',
    isInactivity: false,
    leadRequeriment: '',
    productsConfigurationData: {
      PolicyHolder: {
        LastName: '',
        MobilePhone: '',
        PersonalDataAuthorization: false
      },
      Tenant: {
        DocumentNumber: '',
        DocumentType: ''
      },
      Property: {
        AdministrationValue: 0,
        RentalFee: 0,
        Department: '',
        UseProperty: '',
        // new atrivutes for Property
        DepartmentCode: '',
        CityProperty: '',
        Code: '',
        CityCode: ''
      }
    }
  };

  response!: ResponseServices;
  parametro: string = '';
  planes!: PlanModels;
  sessionId: string = '';
  leadId: string = '';
  @Input() identLead!: string;
  codAsesor: string = '';
  IdBitacora: string = '';
  precioCanon: number = 0;
  segundoCanon: number = 0;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private orquestadorService: OrquestadorService,
    private _dataLayerService: DataLayerService
  ) { }

  getLocalStorage(): number {
    return Number(localStorage.getItem('session_id'))
  }

  @Input() infoCliente?: string;
  @Input() idLead?: string;

  ngOnInit(): void {
    this.sessionId = this.getLocalStorage().toString();

    this.route.paramMap.subscribe((params: ParamMap) => {
      this.leadId = params.getAll('idLead')[0];
      const resultado = params.get('infoCliente');
      this.codAsesor = params.getAll('codigoAsesor')[0];
      this.IdBitacora = params.getAll('bitacoraId')[0];

      if (resultado !== null) {
        this.json = resultado;
        this.jsonFinal = atob(this.json);
        this.datosGenerales = JSON.parse(this.jsonFinal);
        this.parametro = JSON.stringify(this.datosGenerales);

        this.precioCanon = (this.datosGenerales.InfoArrendamiento.valorArriendo + this.datosGenerales.InfoArrendamiento.valorAdministracion) * 0.5;
        const porceCanon = (this.datosGenerales.InfoArrendamiento.valorArriendo + this.datosGenerales.InfoArrendamiento.valorAdministracion) * 0.35;
        this.segundoCanon = porceCanon;
      }
      else {
        const paramInfoCliente = this.infoCliente;
        const paramIdLead = this.idLead;
        this.leadId = paramIdLead !== undefined ? paramIdLead : '';

        if (paramInfoCliente !== undefined) {
          this.json = paramInfoCliente;
          this.jsonFinal = atob(this.json);
          this.datosGenerales = JSON.parse(this.jsonFinal);
          this.parametro = JSON.stringify(this.datosGenerales);

          this.precioCanon = (this.datosGenerales.InfoArrendamiento.valorArriendo + this.datosGenerales.InfoArrendamiento.valorAdministracion) * 0.5;
          const porceCanon = (this.datosGenerales.InfoArrendamiento.valorArriendo + this.datosGenerales.InfoArrendamiento.valorAdministracion) * 0.35;
          this.segundoCanon = porceCanon;
        }
      }
    });

    this.dataCarga.getPriceData = true;
    this.dataCarga.productsConfigurationData.Property.TemporaryContracted = '6';
    this.dataCarga.productsConfigurationData.Property.AdministrationValue = this.datosGenerales.InfoArrendamiento.valorAdministracion;
    this.dataCarga.productsConfigurationData.Property.RentalFee = this.datosGenerales.InfoArrendamiento.valorArriendo;
    this.dataCarga.productsConfigurationData.Property.Department = this.datosGenerales.InfoArrendamiento.ubicacion;

    this.orquestadorService.postOrquestadorPlanes(this.dataCarga).
      subscribe(
        (data) => {
          this.planes = data;
        },
        (error) => {
          this.router.navigate([ERROR, { porcPll: '25', msnPll: 'Falla en el servicio de Tarificación sin inquilino', infoViaje: btoa(this.parametro) }]);
          return;
        }
      );
  }

  ResumenPlan(code: number) {

    this._dataLayerService.logPlanes('ecommerce_step_4', 'Arrendamiento', 'Planes sin inquilino',
      this.sessionId, this.datosGenerales.InfoArrendamiento.valorArriendo.toString(),
      this.datosGenerales.InfoArrendamiento.valorAdministracion.toString(),
      this.datosGenerales.InfoArrendamiento.tipoPropiedad,
      this.datosGenerales.InfoArrendamiento.ubicacion, this.datosGenerales.InfoArrendamiento.ubicacion,
      this.datosGenerales.InfoArrendamiento.duracionContrato,
      this.datosGenerales.InfoArrendamiento.fechaContrato, this.planes.data[code].planName,
      this.planes.data[code].price.toString(), this.datosGenerales.InfoArrendamiento.ServiciosPublicos ? 'true' : 'false',
      this.datosGenerales.InfoArrendamiento.PaquetesAsistencia ? 'true' : 'false');

    this.GuardarDataLayer(code);
    this.router.navigate([FIN_FLUJO_NO, { codigoAsesor: this.codAsesor, idLead: this.leadId, infoCliente: btoa(this.parametro), bitacoraId: this.IdBitacora }]);
  }

  ArmarPlan(code: number) {
    this.datosGenerales.PlanSeleccionado.plan = this.planes.data[code].planName;
    this.datosGenerales.PlanSeleccionado.valorPlan = this.planes.data[code].price;
    this.parametro = JSON.stringify(this.datosGenerales);

    this.GuardarDataLayer(3);
    // this.router.navigate([FIN_FLUJO_NO, { codigoAsesor: this.codAsesor, idLead: this.leadId, infoCliente: btoa(this.parametro), bitacoraId: this.IdBitacora }]);
    // TODO REVISAR VALIDAR
    this.router.navigate(['ArmaTuPlanNo', { codigoAsesor: this.codAsesor, idLead: this.leadId, infoCliente: btoa(this.parametro), bitacoraId: this.IdBitacora }]);
  }

  private GuardarDataLayer(code: number) {
    this.dataEnvioCotizador.SessionId = this.sessionId;
    this.dataEnvioCotizador.productFamily = "Arrendamientos";
    this.dataEnvioCotizador.screenPercentage = '10'
    this.dataEnvioCotizador.leadId = this.leadId == 'undefined' ? "" : this.leadId;
    this.dataEnvioCotizador.bitacoraId = this.IdBitacora == 'undefined' ? "" : this.IdBitacora;

    if (this.codAsesor === 'undefined') {
      this.codAsesor = '';
      this.dataEnvioCotizador.asesorCode = this.codAsesor;
    }

    if (this.codAsesor != '') {
      this.dataEnvioCotizador.asesorCode = this.codAsesor;
    }
    else {
      this.dataEnvioCotizador.asesorCode = this.codAsesor;
    }

    this.dataEnvioCotizador.isInactivity = false;
    this.dataEnvioCotizador.leadRequeriment = code === 1 ? 'plan esencial sin inquilino' : code === 2 ? 'plan plus sin inquilino' : 'Plan arma tu plan sin inquilino';
    this.dataEnvioCotizador.productsConfigurationData.PolicyHolder.LastName = this.datosGenerales.Cliente.nombreCliente;
    this.dataEnvioCotizador.productsConfigurationData.PolicyHolder.MobilePhone = this.datosGenerales.Cliente.celularCliente.toString();
    this.dataEnvioCotizador.productsConfigurationData.PolicyHolder.PersonalDataAuthorization = true;
    this.dataEnvioCotizador.productsConfigurationData.Tenant.DocumentNumber = this.datosGenerales.Cliente.cedulaCliente.toString();
    this.dataEnvioCotizador.productsConfigurationData.Tenant.DocumentType = this.datosGenerales.Cliente.tipoIdentificacion;
    this.dataEnvioCotizador.productsConfigurationData.Property.AdministrationValue = this.datosGenerales.InfoArrendamiento.valorAdministracion;
    this.dataEnvioCotizador.productsConfigurationData.Property.RentalFee = this.datosGenerales.InfoArrendamiento.valorArriendo;
    this.dataEnvioCotizador.productsConfigurationData.Property.Department = this.datosGenerales.InfoArrendamiento.ubicacion;
    this.dataEnvioCotizador.productsConfigurationData.Property.UseProperty = this.datosGenerales.InfoArrendamiento.tipoPropiedad;

    this.dataEnvioCotizador.productsConfigurationData.Property.Code = this.datosGenerales.InfoArrendamiento.Code;
    this.dataEnvioCotizador.productsConfigurationData.Property.CityCode = this.datosGenerales.InfoArrendamiento.CityCode;
    this.dataEnvioCotizador.productsConfigurationData.Property.DepartmentCode = this.datosGenerales.InfoArrendamiento.DepartmentCode;
    this.dataEnvioCotizador.productsConfigurationData.Property.CityProperty = this.datosGenerales.InfoArrendamiento.CityProperty;


    this.orquestadorService.postOrquestadorEnvioGen(this.dataEnvioCotizador).
      subscribe(
        (data) => {
          this.response = data;
        }
      );
  }

}
